import { facetDataMiddleware } from './facetDataMiddleware';

export default [facetDataMiddleware];
